import { CLASSIFICATION_TYPE } from "../../constants";
import { eventPagePayloadCreator } from "../../helpers/eventPayloadCreator";
import { getPageTypeFromPathname } from "../../helpers/helpers";
import { EventData } from "../../types";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface WelcomePagePayload {}

const WelcomePageViewedAnalyticsEvent: EventData = {
  pageDetail: "",
  pageType: getPageTypeFromPathname(),
  eventName: "Welcome Page Viewed",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createWelcomePageViewedPageEventPayload =
  eventPagePayloadCreator<WelcomePagePayload>(WelcomePageViewedAnalyticsEvent);
